module.exports = __webpack_public_path__ + "static/media/logo.ec77c769.png";